import React, { useMemo } from "react";
import {
  Box,
  Button,
  Card,
  Dialog,
  Grid,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  MenuItem
} from "@mui/material";
import { useFormik } from "formik";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import { useCreateGameUnitMutation, useGetGameQuery } from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import { IGameUnit, IGame, IPrinter } from "../../../Api/Interface/api.interface";
import { useStyles } from "../../../theme/appStyles";
import CustomSwitch from "../../../Components/Switch/CustomSwitch";
import moment from "moment-timezone";

interface IGameUnitpopup {
  openModel?: boolean;
  handleCloseDialog: (close: boolean) => void;
  data?: IGameUnit;
}

const Coursing = ({
  openModel = false,
  handleCloseDialog,
  data,
}: IGameUnitpopup) => {
  const classes = useStyles();
  const [open] = React.useState(openModel);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [newLocation, { isLoading }] = useCreateGameUnitMutation();
  const { data: gamesData } = useGetGameQuery({ searchText: ""});
  const { showErrorMessage, showMessage } = useNotifier();

  const games: IGame[] = Array.isArray(gamesData?.data)
          ? (gamesData?.data as IGame[])
          : [];
  
  const handleClose = () => {
    handleCloseDialog(false);
  };

  const formik = useFormik({
  initialValues: {
    id: data?.id ,
    game_id: data?.game?.id || "",
    name: data?.name ?? "",
    capacity: data?.capacity ?? "",
    position_group: data?.position_group ?? "",
    entry_offset_minutes: data?.entry_offset_minutes ?? "",
    isActive: data?.isActive ? Boolean(data?.isActive) : true,
    },
    onSubmit: async (values) => {
      try {
       
         const temData = {
     id: values?.id,
    game_id: Number(values.game_id),
    name: values.name,
    capacity: values.capacity ? Number(values.capacity) : 0,
    position_group: values.position_group || null,
    entry_offset_minutes: values.entry_offset_minutes
          ? Number(values.entry_offset_minutes)
          : 0,
  isActive: Boolean(values.isActive),
};
    
        if (!data) {
          delete values.id;
        }

        const addCompanyResponse = await newLocation(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          handleClose();
         // console.log((addCompanyResponse.data as IGame).id);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });


    const formValid = useMemo(() => {
        return formik.values.name === "" ||
          formik.values.name === undefined
          ? false
          : true;
      }, [formik]);
    

  const gridHeight = isMobile ? "30px" : "400px";

  return (
    <Dialog
      open={open}
      PaperProps={{
        style: {
          maxWidth: "1700px",
        },
      }}
    >
      <Grid className={classes.Dialog}>
        <Grid container spacing={3}>
          <Grid item lg={3} md={3} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ borderBottom: 2, padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  pt={2}
                  alignContent={"center"}
                >
                  <Typography className={classes.cardTitle}>
                    Edit Game Unit
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item lg={9} md={9} sm={12} xs={12}>
            <form onSubmit={formik.handleSubmit}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Game Unit Information
                        </Typography>
                      </Grid>
                    </Grid>

                       <Grid container spacing={3} p={"24px"}>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                         <Grid item lg={12} md={12} sm={12} xs={12}>
                                                  <Typography variant="subtitle1">
                                                     Game <span style={{ color: "red" }}>*</span>
                                                  </Typography>
                                                </Grid>
                                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                                    <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                {...formik.getFieldProps("game_id")}
                                                className={classes.textField}
                                              >
                                                <MenuItem value="">Select Game</MenuItem>
                                                {games?.map((game: IGame) => (
                                                  <MenuItem key={game.id} value={game.id}>
                                                    {game.name}
                                                  </MenuItem>
                                                ))}
                                              </TextField>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                        
                        
                        
                        
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <Grid container alignItems="center">
                                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                                  <Typography variant="subtitle1">
                                                     Name <span style={{ color: "red" }}>*</span>
                                                  </Typography>
                                                </Grid>
                                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                                  <TextField
                                                    placeholder="Enter Name"
                                                    size="small"
                                                    {...formik.getFieldProps("name")}
                                                    className={classes.textField}
                                                    InputProps={{
                                                      sx: {
                                                        fontSize: 14,
                                                      },
                                                    }}
                                                    InputLabelProps={{
                                                      sx: {
                                                        fontSize: 14,
                                                      },
                                                    }}
                                                  />
                                                </Grid>
                                              </Grid>
                                            </Grid>
                        
                                           
                        
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <Grid container alignItems="center">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Typography variant="subtitle1">Capacity</Typography>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <TextField
                                type="number"
                                size="small"
                                {...formik.getFieldProps("capacity")}
                                className={classes.textField}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <Grid container alignItems="center">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Typography variant="subtitle1">Position Group</Typography>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <TextField
                                size="small"
                                {...formik.getFieldProps("position_group")}
                                className={classes.textField}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        
                        
                        
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <Grid container alignItems="center">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Typography variant="subtitle1">Entry Offset (Minutes)</Typography>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <TextField
                                type="number"
                                placeholder="Entry Offset (Minutes)"
                                size="small"
                                {...formik.getFieldProps("Entry Offset (Minutes)")}
                                className={classes.textField}
                                inputProps={{ min: "0" }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        
                        
                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                              <Grid container alignItems="center">
                                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                                  <Typography variant="subtitle1">Active</Typography>
                                                </Grid>
                                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                                  <CustomSwitch
                                                    color="primary"
                                                    sx={{ mr: 2 }}
                                                    formik={formik}
                                                    name="isActive"
                                                  />
                                                </Grid>
                                              </Grid>
                                            </Grid>


                    </Grid>
                  </Card>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                  <Card className={classes.card}>
                    <Grid container spacing={3} p={"24px"}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="outlined"
                          startIcon={<CloseIcon />}
                          className={classes.addButton}
                          onClick={handleClose}
                        >
                          Cancel
                        </Button>
                        <Box m={0.5}></Box>

                        <Button
                          variant="contained"
                          startIcon={<SaveAltIcon />}
                          className={classes.addButton}
                          onClick={() => formik.handleSubmit()}
                          disabled={!formValid || isLoading}
                        >
                          Save
                        </Button>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default Coursing;
